import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, Input, SimpleChanges } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-logo-box',
  standalone: true,
  imports: [RouterLink, CommonModule],
  template: `
    <a routerLink="/" class="logo">
    <!-- <span class="logo-light"> -->
      <span class=""><img width="40px" src="assets/images/jata-mufti-160h.png" alt="logo"></span>&nbsp;
      <span *ngIf="divWidth >= 260" style="color:white; font-size: 16px; font-weight: 700">e-Falak Selangor</span>
      <span>{{divWidth}}</span>

      <!-- <span class="logo-sm"><img src="assets/images/logo-sm.png" alt="small logo"></span> -->
    <!-- </span> -->

    <!-- <span class="logo-dark">
      <span class="logo-lg"><img src="assets/images/logo-dark.png" alt="dark logo"></span>
      <span class="logo-sm"><img src="assets/images/logo-sm.png" alt="small logo"></span>
    </span> -->
  </a>`,
})

export class LogoBoxComponent {
  @Input() divWidth:any
  constructor(private cdr: ChangeDetectorRef) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['divWidth']) {
      console.log('Div width updated:', this.divWidth);
      console.log('Div width updated in child:', changes['divWidth'].currentValue);
      this.cdr.markForCheck();
    }
  }
}
